export function encodeBase64(input: string): string {
  return encodeURIComponent(btoa(unescape(encodeURIComponent(input))));
}
